import React from "react";
import style from "./About.module.css";

const About = () => {
  return <div className={style.About}>About</div>;
};

export default About;
